import React from 'react';
import { Redirect } from 'react-router-dom'
import {Form, FormGroup, FormControl, Col, ControlLabel, Button, Alert} from 'react-bootstrap';
import Auth from './auth.js'

export default class SignUp extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            alert: "",
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
    }

    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }

    handleAlertDismiss() {
        this.setState({alert: ""});
    }

    handleSubmit(event) {
        event.preventDefault();
        let _this = this;
        Auth.authenticate(this.state.email, this.state.password).then((result) => {
            _this.setState({email: ""});
            _this.forceUpdate();
        }).catch((error) => {
            _this.setState({alert: error.message});
        });
        _this.setState({password: ""});
        return false;
    }

    render() {

        const { from } = this.props.location.state || { from: { pathname: '/' } };

        if (Auth.isAuthenticated){
            return (
                <Redirect to={from} />
            )

        }
        return (
            <div>
                <h1>
                    Sign in
                </h1>
                {this.state.alert !== "" &&
                <Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
                    <h4>Error</h4>
                    <p>{this.state.alert}</p>
                </Alert>
                }
                <Form horizontal onSubmit={this.handleSubmit}>
                    <FormGroup controlId="formHorizontalEmail">
                        <Col componentClass={ControlLabel} sm={2}>
                            Email
                        </Col>
                        <Col sm={10}>
                            <FormControl type="email" name="email" placeholder="Email" value={this.state.email} onChange={this.handleChange}/>
                        </Col>
                    </FormGroup>

                    <FormGroup controlId="formHorizontalPassword">
                        <Col componentClass={ControlLabel} sm={2}>
                            Password
                        </Col>
                        <Col sm={10}>
                            <FormControl type="password" name="password" placeholder="Password" value={this.state.password} onChange={this.handleChange}/>
                        </Col>
                    </FormGroup>

                    <FormGroup>
                        <Col smOffset={2} sm={10}>
                            <Button type="submit" bsStyle="primary">
                                Sign in
                            </Button>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }

};


// WEBPACK FOOTER //
// ./src/sign-in.js